<template>
  <div class="container p-3 mr-2 ml-2">
    <!-- <div class="row" style="height:8vh">
          <div class="col-12 border">
              <div class="controls p-2" v-if="isActive">
                <input type="color" v-model="color" />
                <button class="btn-orange" @click="$refs.paintable.clearCanvas">پاک</button>
                <button class="btn-success text-light" @click.prevent="SavePaint()">ذخیره</button>
                <button class="btn-danger text-light" @click="$refs.paintable.cancelDrawing">انصراف</button>
              </div>
          </div>
    </div> -->
    <div class="row">
      <div class="col-12 p-2 border">
        <div class="col-12 border" style="height: 50vh">
          <paintable
            :active="isActive"
            :disableNavigation="false"
            :hide="hidePaintable"
            :horizontalNavigation="false"
            :navigation="navigation"
            :name="isFirstPaintable ? 'my-screen' : 'my-second-screen'"
            :factor="1"
            :width="500"
            :height="500"
            :showLineWidth="false"
            :lineWidth="dynamicLineWidth"
            :lineWidthEraser="20"
            :showUndoRedo="false"
            :color="color"
            :useEraser="false"
            class="paint"
            ref="paintable"
            @toggle-paintable="toggledPaintable"
          >
            <div class="control">
              <!-- <h3>
                Paintable <strong>{{ isFirstPaintable ? '1' : '2' }}</strong>
              </h3> -->

              <!-- <button @click="hidePaintable = !hidePaintable">show/hide</button>
              <button @click="disableNavigation = !disableNavigation">
                toggle navigation
              </button>
              <button @click="navigate">switch to another paintable</button> -->
            </div>
          </paintable>
        </div>
      </div>
    </div>

    <!-- 
    <div class="custom-navigation">

    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">


        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isFirstPaintable: true,
      hidePaintable: false,
      disableNavigation: true,
      dynamicLineWidth: 4,
      isActive: false,
      useEraser: false,
      color: "#000",
      myscreen: null,
    };
  },
  computed: {
    navigation() {
      return {
        "draw-save": {
          body: "شروع",
          activeBody: "<strong>ذخیره</strong>",
        },
        color: {
          body: "رنگ",
        },
        undo: {
          body: "عملیات معکوس",
        },
        redo: {
          body: "تکرار عملیات آخر",
        },
        delete: {
          body: "حذف",
        },
        cancel: {
          body: "بازگشت",
        },
        eraser: {
          body: "پاک کن",
        },
        pencil: {
          body: "قلم",
        },
        useEraser: false,
      };
    },
  },
  methods: {
    SavePaint() {
      alert("saveprint");
      this.$refs.paintable.saveCurrentCanvasToStorage;
      this.myscreen = localStorage.getItem("my-screen");
      var img = JSON.parse(JSON.stringify(this.myscreen));
      document.getElementById(this.idshowimg).setAttribute("src", img);
      document.getElementById(this.iduploader).value = img;
      localStorage.removeItem("my-screen");
      alert("save");
    },
    navigate() {
      this.isFirstPaintable = !this.isFirstPaintable;
    },
    hide() {
      this.$hidePaintableNavigation();
    },
    show() {
      this.$showPaintableNavigation();
    },
    toggledPaintable(isActive) {
      console.log(isActive);
      if (this.Actived) {
        if (isActive == false) {
          this.$refs.paintable.saveCurrentCanvasToStorage;
          this.myscreen = localStorage.getItem("my-screen");
          var img = JSON.parse(JSON.stringify(this.myscreen));
          document.getElementById(this.idshowimg).setAttribute("src", img);
          document.getElementById(this.iduploader).value = img;
        }
      }

      this.isActive = isActive;
    },
  },
  created() {
    console.log("active paint", this.Actived);
  },
  props: ["idshowimg", "iduploader", "Actived"],
};
</script>

<style scoped>
.paint {
  /* border: 1px solid #000; */
  /* border-radius: 5%; */
  margin: auto;
  box-sizing: border-box;
  display: block;
  position: relative !important;
  overflow: hidden;
}
footer {
  text-align: center;
}
footer a {
  color: #777;
  text-transform: uppercase;
  text-decoration: none;
}
button {
  border: 1px solid;
  margin: 0;
  font-size: 14px;
  padding: 4px;
  opacity: 0.8;
  cursor: pointer;
}
input {
  cursor: pointer;
  margin-top: 3px !important;
  margin-bottom: 0px !important;
  background: transparent;
}

.custom-navigation {
  position: fixed;
  top: 40px;
  left: 40px;
  z-index: 1001;
  background-color: #fff;
}
.custom-navigation .controls {
  margin: 10px 0 0 0;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
}
</style>
